import React, { useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { TextButton } from "@qgiv/core-donor";
import ConnectedRegistrationSummary from "./ConnectedRegistrationSummary";
import "./MobileRegistrationSummary.scss";

const MobileRegistrationSummary = ({
    displayPromoCodePrompt = false,
    displayUnconfirmedRegistrationsError = false,
    summaryHeading,
    mobileAddPromoCodeLabel,
}) => {
    const [displaySummary, setDisplaySummary] = useState(false);
    return (
        // eslint-disable-next-line tailwindcss/classnames-order
        <div className="mobile-registration-summary grid grid--no-gutters">
            <div className="mobile-registration-summary__col col--12 -text--center">
                <TextButton
                    styles="mobile-registration-summary__toggle"
                    handleClick={(e) => {
                        e.preventDefault();
                        setDisplaySummary(!displaySummary);
                    }}
                >
                    <strong className="-type--regular">
                        <Icon
                            type="FontAwesome"
                            glyph={
                                displaySummary
                                    ? "minus-circle-regular"
                                    : "plus-circle-regular"
                            }
                        />{" "}
                        {summaryHeading}
                        {displayPromoCodePrompt && (
                            <span>
                                {" • "} {mobileAddPromoCodeLabel}
                            </span>
                        )}
                    </strong>
                    {displayUnconfirmedRegistrationsError && (
                        <>
                            <br />
                            <strong className="-type--small -color--system-error">
                                <Icon
                                    type="FontAwesome"
                                    glyph="exclamation-circle-solid"
                                />
                                {" Review Details"}
                            </strong>
                        </>
                    )}
                </TextButton>
            </div>
            {displaySummary && (
                <div className="mobile-registration-summary__col col--12">
                    <div className="mobile-registration-summary__summary">
                        <ConnectedRegistrationSummary displayHeader={false} />
                    </div>
                </div>
            )}
        </div>
    );
};

MobileRegistrationSummary.propTypes = {
    displayPromoCodePrompt: PropTypes.bool.isRequired,
    // Flag indicating that registrations need to be confirmed
    displayUnconfirmedRegistrationsError: PropTypes.bool.isRequired,
    // Summary heading text
    summaryHeading: PropTypes.string.isRequired,
    mobileAddPromoCodeLabel: PropTypes.string.isRequired,
};

export default MobileRegistrationSummary;
